export enum EPresetOption {
    Opportunities = "Opportunities",
    Losses = "Losses",
    Wins = "Wins",
    HighlyCompetitive = "HighlyCompetitive",
    Overlapping = "Overlapping",
    Cannibalization = "Cannibalization",
    LongTail = "LongTail",
    SerpFeatures = "SerpFeatures",
    HighTraffic = "HighTraffic",
    LowPotential = "LowPotential",
}
